// src/pages/Library.js
import React from "react";
import { motion } from "framer-motion";
import HeroCarousel from "../Components/HeroCarousel";
import BookCarousel from "../Components/BookCarousel";
import sampleBooks from "../data/sampleBooks";
import "../styles/Library.css";

const Library = () => {
  // 1) Find unique CEFR levels
  const uniqueLevels = new Set();
  sampleBooks.forEach(b => b.cefrLevels?.forEach(level => uniqueLevels.add(level)));

  // 2) Level mapping: CEFR to display level
  const levelMap = {
    A2: "Level 1",
    B1: "Level 2",
    B2: "Level 3",
    C1: "Level 4",
    C2: "Level 5",
  };

  // 3) Find unique genres
  const uniqueGenres = new Set();
  sampleBooks.forEach(b => b.genres?.forEach(genre => uniqueGenres.add(genre)));

  // 4) Combine final carousels
  const carousels = [
    { title: "Featured", filter: (b) => b.isFeatured },
    ...Array.from(uniqueLevels).map(level => ({
      title: levelMap[level] || level, // fallback just in case
      filter: (b) => b.cefrLevels.includes(level),
    })),
    ...Array.from(uniqueGenres).map(genre => ({
      title: genre,
      filter: (b) => b.genres.includes(genre),
    })),
  ];

  const limitedCarousels = carousels.slice(0, 10);

  return (
    <motion.div
      className="library-page"
      style={{
        background: "linear-gradient(135deg, #0d0d0d 30%, #7c3aed 100%)",
        minHeight: "100vh",
      }}
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -20 }}
      transition={{ duration: 0.5, ease: "easeInOut" }}
    >
      <div className="hero-banner-wrapper">
        <HeroCarousel />
      </div>

      <div className="carousels-container">
        {limitedCarousels.map(({ title, filter }) => {
          const booksInCategory = sampleBooks.filter(filter);
          if (booksInCategory.length === 0) return null;
          return (
            <BookCarousel
              key={title}
              title={title}
              books={booksInCategory}
            />
          );
        })}
      </div>

      {/* Footer */}
      <div className="mt-8 mb-6 text-sm text-gray-500 text-center space-y-1">
        <p className="mt-2">
          © 2025 Chaptr.org. All rights reserved.
          <br />
          Terms & Conditions | Privacy Policy | Cookies |{" "}
          <a
            href="mailto:info@chaptr.org"
            className="underline hover:text-gray-400"
          >
            Contact
          </a>
        </p>
      </div>
    </motion.div>
  );
};

export default Library;
